import { HTMLProps, forwardRef, useContext } from 'react'

import { Box, Button, Checkbox, Table } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import MapSelector from 'modules/employees/pages/ImportProcessPage/components/ImportProcessWizard/MapColumnsStep/components/MapSelector'
import { TableContext } from '../context'

const TableWrapper = forwardRef<HTMLDivElement, HTMLProps<HTMLDivElement>>(function TableWrapper({
  children,
}) {
  const {
    rows,
    mappings,
    fields,
    headers,
    allSelected,
    handleCheckboxToggle,
    tableHeadRef,
    tableBodyRef,
    onClearFilter,
  } = useContext(TableContext)

  return (
    <Table hideBorder noRadius overflowX="hidden">
      <Table.Head ref={tableHeadRef}>
        <Table.Row>
          <Table.HeadCell
            style={{ minWidth: '40px', width: '40px' }}
            padding="s0"
            background="grey000White"
          />
          {mappings?.map((mapping, index) => {
            return (
              <Table.HeadCell key={index} width={240} paddingX="s2" background="grey000White">
                <MapSelector
                  selectedValue={mapping.fieldName}
                  fields={fields || []}
                  index={index}
                  isDisabled
                />
              </Table.HeadCell>
            )
          })}
        </Table.Row>
        <Table.Row>
          <Table.HeadCell padding="s0" justifyContent="center">
            <Box>
              <Checkbox checked={allSelected} onChange={handleCheckboxToggle} />
            </Box>
          </Table.HeadCell>
          {headers?.map(
            (columnName, index) =>
              columnName !== undefined && (
                <Table.HeadCell key={index} ellipsis paddingX="s16">
                  {columnName}
                </Table.HeadCell>
              )
          )}
        </Table.Row>
      </Table.Head>
      <Table.Body ref={tableBodyRef}>
        {!!rows?.length ? (
          children
        ) : (
          <Table.Row>
            <Table.Cell colSpan={headers?.length} verticalAlign="baseline" paddingY="s140">
              <Box flexDirection="row" justifyContent="center">
                <Button type="negative" onClick={() => onClearFilter && onClearFilter(undefined)}>
                  {i18n.t('filters.clear_filter')}
                </Button>
              </Box>
            </Table.Cell>
          </Table.Row>
        )}
      </Table.Body>
    </Table>
  )
})

export default TableWrapper
